module.exports = __webpack_public_path__ + "media/images/plans/plan-online-chapel-2096bbabc5f9019ee33f55f382af435c.png";